'use client';

import { createTheme } from '@mantine/core';

export const theme = createTheme({
  breakpoints: {
    xs: '576px',
    sm: '840px',
    md: '992px',
    lg: '1200px',
    xl: '1400px',
  },
  fontFamily: 'Outfit',
});
